var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup163222(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_163222",
    "data-name": "Group 163222",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 304,
    height: 150.987,
    viewBox: "0 0 304 150.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148196",
    "data-name": "Rectangle 148196",
    width: 304,
    height: 150.987,
    rx: 15,
    fill: "#ec9859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_732",
    x: 93.687,
    y: -195.127,
    width: 418.6,
    height: 420.627,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_733",
    x: -184.98,
    y: -51.233,
    width: 421.64,
    height: 421.64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_734",
    x: 134.22,
    y: -104.94,
    width: 370.973,
    height: 371.987,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active_Tab_Indicator",
    "data-name": "Active Tab Indicator",
    transform: "translate(0.274 0.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162446",
    "data-name": "Group 162446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147724",
    "data-name": "Rectangle 147724",
    width: 303.453,
    height: 149.775,
    rx: 15,
    fill: "#865fb4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163191",
    "data-name": "Group 163191",
    transform: "translate(-36.48 -47.627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 36.48, 47.63)",
    filter: "url(#Ellipse_732)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_732-2",
    "data-name": "Ellipse 732",
    cx: 60.8,
    cy: 61.813,
    rx: 60.8,
    ry: 61.813,
    transform: "translate(242.19 -47.63)",
    fill: "#40196d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 36.48, 47.63)",
    filter: "url(#Ellipse_733)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_733-2",
    "data-name": "Ellipse 733",
    cx: 62.32,
    cy: 62.32,
    r: 62.32,
    transform: "translate(-36.48 96.27)",
    fill: "#3e186a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 36.48, 47.63)",
    filter: "url(#Ellipse_734)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_734-2",
    "data-name": "Ellipse 734",
    cx: 36.987,
    cy: 37.493,
    rx: 36.987,
    ry: 37.493,
    transform: "translate(282.72 42.56)",
    fill: "#6c63ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163222);
export default __webpack_public_path__ + "static/media/Group 163222.0dc83ce63802add4183db871a052e19c.svg";
export { ForwardRef as ReactComponent };